import React, { PropsWithChildren } from 'react'
import { Grid } from '..'

/**
 * Set up a grid layout that matches the Design system
 */
export const LayoutGrid = ({
    columns = 'one',
    variant = 'regular',
    children
}: PropsWithChildren<{
    columns: 'one' | 'two' | 'three'
    variant?: 'regular' | 'condensed'
}>) => {
    const configMap = {
        one: {
            columns: 1,
            maxWidth: {
                regular: 480,
                condensed: 380
            },
            gap: {
                regular: 0,
                condensed: 0
            }
        },
        two: {
            columns: [1, 2],
            maxWidth: {
                regular: 768,
                condensed: 768
            },
            gap: {
                regular: 7,
                condensed: 4
            }
        },
        three: {
            columns: [1, 2, 3],
            maxWidth: {
                regular: '100%',
                condensed: '100%'
            },
            gap: {
                regular: 7,
                condensed: 4
            }
        }
    }
    const config = configMap[columns]

    return (
        <Grid
            columns={config.columns}
            gap={config.gap[variant]}
            sx={{
                width: '100%',
                maxWidth: config.maxWidth[variant],
                mx: 'auto'
            }}
        >
            {children}
        </Grid>
    )
}
